import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://322045f5a01c0bed2585912cbd5296e9@o164625.ingest.us.sentry.io/4507291211595776",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/romashov\.tech/,
    /^https:\/\/www.romashov\.tech/,
  ],
});
